import { Button } from '@/components/ui/button'

interface SyncBranchModalProps {
  open: boolean
  title: string
  description: string
  confirmLabel: string
  singleLabel: string
  onSyncAll: () => void
  onSingleOnly: () => void
  onCancel: () => void
}

export function SyncBranchModal({
  open,
  title,
  description,
  confirmLabel,
  singleLabel,
  onSyncAll,
  onSingleOnly,
  onCancel,
}: SyncBranchModalProps) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative z-50 w-full max-w-md rounded-xl border border-border bg-card p-6 shadow-lg mx-4">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <p className="mt-2 text-sm text-muted-foreground">{description}</p>
        <div className="mt-6 flex flex-col gap-2">
          <Button onClick={onSyncAll}>{confirmLabel}</Button>
          <Button variant="outline" onClick={onSingleOnly}>
            {singleLabel}
          </Button>
          <Button variant="ghost" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  )
}
